export default "./images/ED40.jpg";